const initCardToggle = () => {
    const cardAccordion = document.querySelectorAll('#accordian-top-js');
    if (cardAccordion) {
    cardAccordion.forEach((card) => {
        card.addEventListener('click', (event) => {
            const arrow = card.children[0].children[1];
            arrow.classList.toggle('fa-chevron-up');
            arrow.classList.toggle('fa-chevron-down');
            
            const cardContent = card.parentElement.parentElement.children[1];
            cardContent.classList.toggle('show');
        });
    });
    };
}

export { initCardToggle };
